export const trackEvent = (eventName, returnId, metaData) => {
    if (!window.heap) {
        return;
    }
    try {
        var data = Object.assign({}, metaData, { returnId: returnId });
        window.heap.track(eventName, data)
        // leaving for now - usefule for debugging - console.log('Event tracked', eventName, data)
    }
    catch (e) {
        console.log('Failed to send event to Analytics API')
        console.log(e)
    }
}

export const HeapEvents = {
    INTERVIEW_RESET: 'Spark-InterviewReset',
    PREPARE_RETURN_RESET: 'Spark-PrepareReturnReset',
    AUTH_RESET_PRIMARY: 'Spark_AuthorizationResetPrimary',
    AUTH_RESET_SPOUSE: 'Spark_AuthorizationResetSpouse',
    COMPLETE_CONFIRM_PAYMENT: 'Spark_ConfirmPayment',
    COMPLETE_PREPARE_RETURN: 'Spark_PrepareReturn',
    COMPLETE_RETURN_PRIMARY: 'Spark-ReturnCompletePrimary',
    COMPLETE_RETURN_SPOUSE: 'Spark-ReturnCompleteSpouse',
    SEND_MESSAGE: 'Spark-SendMessage',
    REASSIGN_TICKET: 'Spark-Reassign',
    REOPEN_TICKET: 'Spark-Reopen',
    RECOVER_FILE: 'Spark-RecoverFile',
    CREATE_NOTE: 'Spark-CreateNote',
    COMPLETE_PREPARE_Payment: 'Spark_PreparePayment',
    COMPLETE_RTE_FILE_RETURN: 'Spark-FileReturnCompleteRTE',
    DOX_BTN_DOWNLOADALL: 'Documents-btn-downloadall',
    DOCUMENT_REVIEW_AUTHORIZATION_PASS: 'DocReview-1-AuthPassed',
    DOCUMENT_REVIEW_AUTHORIZATION_BYPASS: 'DocReview-1-Bypassed',
    DOCUMENT_REVIEW_SEND_AUTHORIZATION_REQUEST: 'DocReview-1-SendRequest',
    DOCUMENT_REVIEW_MYACCOUNT: 'DocReview-1a-MyAccount',
    DOCUMENT_REVIEW_SIGNATURE_PAGE: 'DocReview-1a-Signature',
    DOCUMENT_REVIEW_CLIENT_ACCEPTED: 'DocReview-auth-Accepted',
    DOCUMENT_REVIEW_SIGNATURE_PAGE_SUBMITTED: 'DocReview-auth-SigSubmitted'
}